import {
  Button,
  Collapse,
  ExpandMoreRoundedIcon,
  FilterListOutlinedIcon,
  Flex,
  Rotate,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { UserFilterForm } from '../user-filter-form';
import { UserSearchBox } from '../user-search-box';

export default function UserSearchAndFilterForm() {
  const [isUserFilterOpen, userFilterHandlers] = useDisclosure();
  const { toggle } = userFilterHandlers;

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4) })}>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <UserSearchBox />
        <Button
          size='large'
          variant='outlined'
          color='secondary'
          startIcon={<FilterListOutlinedIcon />}
          onClick={toggle}
          endIcon={
            <Rotate in={isUserFilterOpen}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          }
        >
          Filter
        </Button>
      </Flex>
      <Collapse in={isUserFilterOpen} timeout='auto' unmountOnExit>
        <UserFilterForm />
      </Collapse>
    </Flex>
  );
}
